module.exports = __webpack_public_path__ + "static/media/nach_geburt.3630cdc9.jpg";